import { useRef } from "react";
import { useSelector } from "react-redux";
import { useGetUnreadTotalQuery } from "../store/api/messageRoomApiSlice";
import userTypes from "../constants/userTypes";
import { parseUnreadTotalPayload } from "../utils/messageUnreadCounts";

/**
 * Mesaj rozeti: tek kaynak okunmamış mesaj API'si.
 * FCM sadece invalidate ile bu sorguyu yeniler; rozeti şişirmez.
 */
export function useMessageBadgeCount() {
  const userTypeRaw = useSelector(
    (s) => s.auth?.user?.userType || s.auth?.role?.name || ""
  );
  const normalized = String(userTypeRaw).toUpperCase();

  const enabled =
    normalized === userTypes.DOCTOR ||
    normalized === userTypes.PATIENT ||
    normalized === userTypes.ASSISTANT;

  const { data: unreadTotalRes } = useGetUnreadTotalQuery(undefined, {
    skip: !enabled,
    pollingInterval: 15000,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  const lastUnreadTotalRef = useRef(0);
  const parsed = parseUnreadTotalPayload(unreadTotalRes);
  if (parsed !== null) {
    lastUnreadTotalRef.current = parsed;
  }
  const badgeCount = parsed !== null ? parsed : lastUnreadTotalRef.current;

  return { badgeCount, enabled };
}

/** Menü `to` alanı messages sayfasına mı (messages veya messages/...) */
export function isMessagesMenuRoute(to) {
  if (to == null || to === "") return false;
  const first = String(to).replace(/^\/+/, "").split("/")[0];
  return first === "messages";
}
